m = require 'mithril'

GameViewOptions = {
	view: (ctrl, args) ->
		m '.viewoptions', [
			m 'span.viewoptions__heading', 'View:'
			m 'label.viewoptions__label', [
				m 'input[type=radio][name=viewoptions]', {
					checked: !args.showGraphs()
					onchange: m.withAttr 'checked', (checked) -> args.showGraphs !checked
				}
				'Details'
			]
			m 'label.viewoptions__label', [
				m 'input[type=radio][name=viewoptions]', {
					checked: args.showGraphs()
					onchange: m.withAttr 'checked', args.showGraphs
				}
				'Graph'
			]
		]
}

module.exports = GameViewOptions